import React from 'react'

import Link from '@Pure/Link'

export const form =
{
	model: 'TicketType'.toLowerCase(),
	name: 'TicketType'.toLowerCase(),

	form_title: 'Type de billet',

	fields:
	{
		'label':
		{
			label: 'Libellé'
		}
	},

	create_label: 'Créer ce type de billet',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer ce type de billet&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['tickettype[label]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					Le nouveau type de billet <strong> { model.label } </strong> a été créé.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/types-de-billet/' + model.id }>
						Voir le type de billet
					</Link>
				</div>
			</div>
		);

		return output;
	}
};

export const list =
{
	model: 'TicketType'.toLowerCase(),
	title: 'Liste des types de billet',
	link: '/configuration/types-de-billet',
	creation_link: '/configuration/nouveau-type-de-billet',
	creation_label: 'Nouveau type de billet',
	header_map:
	{
		'Libellé': 'label'
	},
	row_link_base: '/configuration/types-de-billet/',
	searched_prop: 'label'
};

let config = Object.assign({ }, form);

Object.assign(config, list);

export default config